<template>
  <div>
<!--    <div class="a-container-form">-->
<!--      <label class="a-label">Показаны партии:</label>-->
<!--    </div>-->
    <div class="a-container-form">
      <ul>
        <li class="a-part-filter">
          <div class="a-checkbox">
            <label class="a-checkbox__label">
              <input class="a-checkbox__input" type="checkbox" v-model="selectedAll">
              <span class="a-checkbox__icon"></span>
              <span class="a-checkbox__text">Все</span>
            </label>
          </div>
        </li>

        <li class="a-part-filter" :class="{
          'a-part-filter__additional': part.isAdditional,
          'a-part-filter__validation-error': validations.$each[idx] && validations.$each[idx].$anyError
        }" v-for="(part, idx) of parts" :key="part.part">
          <div class="a-checkbox">
            <label class="a-checkbox__label">
              <input class="a-checkbox__input"
                     type="checkbox"
                     v-model="filters[idx]"
                     @click="onFilterChange(idx, $event)">
              <span class="a-checkbox__icon"></span>
              <span class="label">Партия {{part.serial}}</span>
            </label>
          </div>
        </li>
      </ul>
    </div>
<!--    <div class="a-group-btn">-->
<!--      <div class="a-group-btn__left">-->
<!--        <button class="gui-btn gui-btn&#45;&#45;red gui-btn&#45;&#45;w-140" >{{$t('buttons.save')}}</button>-->
<!--        <button class="gui-btn gui-btn&#45;&#45;white-border gui-btn&#45;&#45;w-140">{{$t('buttons.cancel')}}</button>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  export default {
    props: {
      parts: {
        type: Array,
        required: true
      },

      validations: {
        type: Object,
        required: true
      },

      value: {
        type: Array
      }
    },

    data: () => ({
      filters: []
    }),

    watch: {
      parts: {
        immediate: true,
        handler() {
          if (this.filters.length > this.parts.length) {
            this.filters.splice(this.parts.length, this.filters.length - this.parts.length);
          }
          else if (this.filters.length < this.parts.length) {
            Array.prototype.push.apply(this.filters, new Array(this.parts.length - this.filters.length));
          }

          this.filterData();
        }
      },

      filters() {
        this.filterData();
      }
    },

    computed: {
      selectedAll: {
        get() {
          const selected = _.filter(this.filters);
          return selected.length === 0 || selected.length === this.parts.length;
        },

        set() {
          this.filters = new Array(this.filters.length);
        }
      },
    },

    methods: {
      onFilterChange(idx, event) {
        this.$set(this.filters, idx, !!event.target.checked);
      },

      filterData(part) {
        let filtered;

        if (this.selectedAll) {
          filtered = this.parts;
        }
        else {
          filtered = this.parts.filter((part, i) => !!this.filters[i]);
        }

        this.$emit('input', filtered);
      }
    }
  }
</script>

<style lang="scss" scoped>
  ul {
    padding:  8px 0 8px 12px;
    display: inline-block;
    min-height: 34px;

    li {
      list-style: none;
      border: 0;
      cursor: default;
      float: left;
      margin-right: 5px;
      margin-top: 2px;
      font-size: 18px;

      border-radius: 13px;
      padding: 8px 14px;

      min-width: 1em;
      box-sizing: content-box;
    }
  }

  .a-part-filter {
    border: 1px solid;
  }

  .a-part-filter__additional {
    border-color: red;
    color: red !important;
  }

  .a-part-filter__validation-error {
    background-color: rgba(227,6, 19, .3);

    .label {
      color: black;
    }
  }

  .a-checkbox {
    .a-checkbox__label {
      margin: 0px;
    }

    .label {
      margin: 0px;
      margin-left: 8px;
    }
  }
</style>
